// ** React Imports
import { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

// ** Custom Components
import Avatar from "@components/avatar";

// ** Utils
import { isUserLoggedIn } from "@utils";

// ** Store & Actions
import { useDispatch } from "react-redux";
// import { handleLogout } from "@store/actions/auth";

// ** Third Party Components
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import {
  User,
  Mail,
  CheckSquare,
  MessageSquare,
  Settings,
  CreditCard,
  HelpCircle,
  Power,
} from "react-feather";
import useAdminStore from "../../../../stores/useAdminStore";
import logo from "../../../../assets/images/logo.jpeg";
import logoPricerite from "../../../../assets/images/Pricerite.png";


// ** Default Avatar Image
import defaultAvatar from "@src/assets/images/portrait/small/avatar-s-11.jpg";

const UserDropdown = () => {
  // ** Store Vars
  const dispatch = useDispatch();
  const history = useHistory();

  // ** State
  const [userData, setUserData] = useState(null);
  const { admin, setAdmin } = useAdminStore();

  //** ComponentDidMount
  // useEffect(() => {
  //   if (isUserLoggedIn() !== null) {
  //     setUserData(JSON.parse(localStorage.getItem("userData")));
  //   }
  // }, []);

  //** Vars
  // const userAvatar = (admin && admin.avatar) || defaultAvatar;
  if (!admin) {
    history.replace(`/login`);
  }

  const userAvatar = admin?.admin_id == 54 ? logoPricerite : logo;
  const userStatus = admin?.admin_id == 54 ? "實惠家居" : "海迅供應鏈";


  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name font-weight-bold">
            {(admin && admin["name"]) || "海迅Staff"}
          </span>
          <span className="user-status">{userStatus}</span>
        </div>
        <Avatar
          img={userAvatar}
          imgHeight="40"
          imgWidth="40"
          status="online"
          // style={{ backgroundColor: "rgb(70,2,5)" }}
        />
      </DropdownToggle>
      <DropdownMenu right>
        {/* <DropdownItem tag={Link} to="#" onClick={(e) => e.preventDefault()}>
          <User size={14} className="mr-75" />
          <span className="align-middle">Profile</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="#" onClick={(e) => e.preventDefault()}>
          <Mail size={14} className="mr-75" />
          <span className="align-middle">Inbox</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="#" onClick={(e) => e.preventDefault()}>
          <CheckSquare size={14} className="mr-75" />
          <span className="align-middle">Tasks</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="#" onClick={(e) => e.preventDefault()}>
          <MessageSquare size={14} className="mr-75" />
          <span className="align-middle">Chats</span>
        </DropdownItem> */}
        <DropdownItem tag={Link} to="/login" onClick={() => setAdmin()}>
          <Power size={14} className="mr-75" />
          <span className="align-middle">登出</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
